<script setup lang="ts">
/**
 * 对应原项目 app/layout.tsx 的 <html>/<body> 外壳。
 *
 * React 版这里是 `<Toaster />` + `{children}`；Vue 版换成自研的 ToastHost +
 * router-view（html/head/body 属性已搬进 index.html）。
 */
import ToastHost from '@/components/ToastHost.vue';
</script>

<template>
  <ToastHost />
  <router-view />
</template>
